import React from 'react';
import style from '../../Styles/Html/CheckBox.module.css';

const CheckBox = ({ name, id, checked, onChange, isbeverage }) => {
    
    return (
        <div className={style.checkBoxContainer}>
            
            <label className={style.switch}>
                <input 
                    type="checkbox" 
                    className={style.targetcheckbox}
                    id={id}
                    checked={checked}  
                    onChange={(e) => onChange(id,e.target.checked)}/>
                <span className={isbeverage === 1 ? style.sliderRoundBeverage  : style.sliderRound }></span>
                
            </label>
            <label className={style.checkboxLabel} htmlFor={id}>
                    {name}
            </label>
         
        </div>
    );
};

export default CheckBox;
